import Cookies from 'js-cookie'
import {XXTEA} from '@/utils/xxtea.min'

const TokenKey = 'octH5User-Token'

const ExpiresInKey = 'octH5User-Expires-In'

const version = '1.0'

const KEY = "Rj8RBwmJNE8EFaWq9lkpD9qls4mvM6Fm";

const sha256 = require("js-sha256").sha256

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    window.localStorage.setItem('ac', "");
    return Cookies.remove(TokenKey)
}

export function getExpiresIn() {
    return Cookies.get(ExpiresInKey) || -1
}

export function setExpiresIn(time) {
    return Cookies.set(ExpiresInKey, new Date().getTime() + (time * 60 * 1000))
}

export function removeExpiresIn() {
    return Cookies.remove(ExpiresInKey)
}

export function reBuildRequestConfig(config, responseType) {
    let token = getToken();
    token = token ? 'Bearer ' + token : "''"
    let ts = new Date().getTime();
    let uuid = ts.toString(16);
    let m = getRandomNum(0, 5)
    let d = getRamNumber();
    let notice = d.toString(16)
    let sha = sha256(ts + uuid + token + version + notice + m)
    let sign = notice + sha.substring(m, m + 64 - 16 - 1) + m;

    let sTime = ts.toString();
    let time = parseInt(sTime.substring(sTime.length - 3, sTime.length));
    let mode1 = (time + parseInt(ts / 1000)) % 5;
    let sha1 = sha256(token + KEY + sTime + uuid + mode1)
    let key1 = sha1.substring(mode1, mode1 + 8) + sha1.substring(32 - 8, 32)
    let offset = mode1 + 32;
    let key2 = sha1.substring(offset, offset + 8) + sha1.substring(64 - 8, 64)
    let body = XXTEA.encryptToBase64(JSON.stringify({
        dev: JSON.stringify({'type': 'web'}),
        data: JSON.stringify(config.data ? config.data : {})
    }), key1);
    config.headers['Authorization'] = token;
    config.headers['ts'] = sTime
    config.headers['v'] = version
    config.headers['sign'] = sign
    config.headers['functionid'] = key1
    config.headers['method'] = XXTEA.encryptToBase64(config.url, key1)
    if (responseType == 'blob') {
        config.url = "/exportapi"
        config.data = body + ""
        config.headers['Content-Type'] = "application/json"
    } else if (responseType == 'upload') {
        config.url = "/uploadapi"
        config.headers['Content-Type'] = "application/x-www-form-urlencoded;charset=utf-8"
    } else {
        config.url = "/webapi"
        config.data = body + ""
        config.headers['Content-Type'] = "application/json"
    }
    config.method = 'post'
    return {key1: key1, key2: key2}
}

// 获取最小值到最大值之前的整数随机数（不包含最大值）
export function getRandomNum(Min, Max) {
    var Range = Max - Min;
    var Rand = Math.random();
    return (Min + Math.round(Rand * Range));
}

//JS获取随机的16位十六进制的数
export function getRamNumber() {
    var result = '';
    for (var i = 0; i < 16; i++) {
        result += Math.floor(Math.random() * 16).toString(16);//获取0-15并通过toString转16进制
    }
//默认字母小写，手动转大写
    return result.toUpperCase();//另toLowerCase()转小写
}

